import {
  Navigate,
  useLocation,
  observer,
  Spin,
  Routes,
  Route,
} from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24675, offsets 200838:204762. Structure and names inferred from code, not screenshots.
import * as React from "react";
import * as LocalizedPathsModule from "./localizedPaths.js";
import * as GetLanguageModule from "../i18n/getLanguage.js";
import * as LocaleContext from "../i18n/I18nProvider.jsx";
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as UsePageTrackingModule from "../hooks/usePageTracking.js";
import { loadArchivedChunk, loadArchivedModule } from "../vendor/runtime.js";
import m from "../content/extracted/24675-m.json";
let h = new Set(m),
  g = "mimo-v2.5-pro",
  modelCache = {},
  modelImports = {
    "mimo-v2.5-pro": () =>
      Promise.all([
        loadArchivedChunk(4022),
        loadArchivedChunk(8827),
        loadArchivedChunk(4413),
      ]).then(() => loadArchivedModule(2655)),
    "mimo-v2.5": () =>
      Promise.all([
        loadArchivedChunk(4022),
        loadArchivedChunk(8827),
        loadArchivedChunk(125),
      ]).then(() => loadArchivedModule(15139)),
    "mimo-v2.5-asr": () =>
      Promise.all([
        loadArchivedChunk(4022),
        loadArchivedChunk(8827),
        loadArchivedChunk(806),
      ]).then(() => loadArchivedModule(99575)),
    "mimo-v2.5-tts": () =>
      Promise.all([
        loadArchivedChunk(4022),
        loadArchivedChunk(8827),
        loadArchivedChunk(5819),
      ]).then(() => loadArchivedModule(74422)),
    "mimo-v2.5-tts-voicedesign": () =>
      Promise.all([
        loadArchivedChunk(4022),
        loadArchivedChunk(8827),
        loadArchivedChunk(2790),
      ]).then(() => loadArchivedModule(66757)),
    "mimo-v2.5-tts-voiceclone": () =>
      Promise.all([
        loadArchivedChunk(4022),
        loadArchivedChunk(8827),
        loadArchivedChunk(4955),
      ]).then(() => loadArchivedModule(1718)),
    "mimo-v2.6-pro": () =>
      Promise.all([
        loadArchivedChunk(4022),
        loadArchivedChunk(8827),
        loadArchivedChunk(5592),
      ]).then(() => loadArchivedModule(7003)),
    "mimo-v2.6-flash": () =>
      Promise.all([
        loadArchivedChunk(4022),
        loadArchivedChunk(8827),
        loadArchivedChunk(8220),
      ]).then(() => loadArchivedModule(10978)),
    "mimo-v2.6-pro-ultraspeed": () =>
      Promise.all([
        loadArchivedChunk(4022),
        loadArchivedChunk(8827),
        loadArchivedChunk(9788),
      ]).then(() => loadArchivedModule(31351)),
  },
  y = m
    .map((e) => {
      var t;
      let Component2;
      return {
        key: e,
        component:
          ((t = modelImports[e]),
          (Component2 = (0, React.lazy)(
            () => (
              modelCache[e]?.promise ||
                (modelCache[e] = {
                  ...modelCache[e],
                  promise: t().then(
                    (t) => ((modelCache[e].component = t.default), t),
                  ),
                }),
              modelCache[e].promise
            ),
          )),
          function (t) {
            let Component = modelCache[e]?.component;
            return Component ? <Component {...t} /> : <Component2 {...t} />;
          }),
      };
    })
    .flatMap(({ key: key, component: component }) => [
      {
        path: `zh-CN/${key}`,
        component: component,
      },
      {
        path: `en-US/${key}`,
        component: component,
      },
    ]);
function Component3() {
  return (
    <Navigate
      to={(0, LocalizedPathsModule.am)(
        (0, LocalizedPathsModule.Oz)((0, GetLanguageModule.getLanguage)()),
        g,
        "/models",
      )}
      replace={true}
    />
  );
}
function N() {
  let { pathname: pathname, search: search, hash: hash } = useLocation(),
    o = pathname.replace(/^\/models\/?/u, "").replace(/\/$/u, ""),
    r = (0, LocalizedPathsModule.Oz)((0, GetLanguageModule.getLanguage)());
  if (!o) return <Component3 />;
  for (let e of ["zh-CN", "en-US"]) {
    if (o === e)
      return (
        <Navigate to={`/models/${e}/${g}${search}${hash}`} replace={true} />
      );
    if (o.startsWith(`${e}/`)) {
      let r = o.slice(e.length + 1);
      if (h.has(r))
        return (
          <Navigate to={`/models/${e}/${r}${search}${hash}`} replace={true} />
        );
      return (
        <Navigate to={`/models/${e}/${g}${search}${hash}`} replace={true} />
      );
    }
  }
  return h.has(o) ? (
    <Navigate to={`/models/${r}/${o}${search}${hash}`} replace={true} />
  ) : (
    <Navigate to={`/models/${r}/${g}${search}${hash}`} replace={true} />
  );
}
let Component5 = observer(() => {
  let e = useLocation(),
    { language: language, setLanguage: setLanguage } = (0,
    LocaleContext.useI18n)(),
    { track: track } = (0, AnalyticsContext.useAnalytics)();
  return (
    (0, UsePageTrackingModule.usePageTracking)(
      track,
      "models_view",
      () => ({
        model_name: e.pathname.split("/").at(-1),
      }),
      {
        reportOnUnmount: true,
        reportOnBeforeUnload: true,
      },
    ),
    (0, React.useEffect)(() => {
      let n = (0, LocalizedPathsModule.EH)(e.pathname);
      if (null != n) {
        if (n !== language) return void setLanguage(n);
        try {
          localStorage.getItem("user_language_preference") !== n &&
            localStorage.setItem("user_language_preference", n);
        } catch {}
      }
    }, [e.pathname, language, setLanguage]),
    (0, React.useEffect)(() => {
      let e = document.querySelector("main");
      e &&
        e.scrollTo({
          top: 0,
          behavior: "auto",
        });
    }, [e.pathname]),
    (0, React.useEffect)(() => {
      let e = m.map((e) => ({
          key: e,
          importFn: modelImports[e],
        })),
        t = async () => {
          for (let t = 0; t < e.length; t += 5) {
            let i = e.slice(t, t + 5);
            (await Promise.allSettled(
              i.map(
                ({ importFn: importFn, key: key }) => (
                  modelCache[key]?.promise ||
                    (modelCache[key] = {
                      promise: importFn().then(
                        (e) => ((modelCache[key].component = e.default), e),
                      ),
                    }),
                  modelCache[key].promise
                ),
              ),
            ),
              await new Promise((e) => {
                setTimeout(e, 100);
              }));
          }
        };
      "requestIdleCallback" in window
        ? window.requestIdleCallback(() => {
            setTimeout(t, 500);
          })
        : setTimeout(t, 2e3);
    }, []),
    (
      <div
        className={
          "flex flex-1 shrink-0 w-full justify-center bg-[var(--color-bg-page)]"
        }
      >
        <div
          className={
            "w-full max-w-[1440px] px-[28px] [@media(min-width:920px)]:px-[24px] flex flex-col"
          }
        >
          <React.Suspense
            fallback={
              <div
                className={
                  "h-[calc(100vh-46px)] flex justify-center items-center"
                }
              >
                <Spin spinning={true} />
              </div>
            }
          >
            <Routes>
              <Route index={true} element={<Component3 />} />
              {y.map(({ path: path, component: component }) => (
                <Route key={path} path={path} element={<component />} />
              ))}
              <Route path={"*"} element={<N />} />
            </Routes>
          </React.Suspense>
        </div>
      </div>
    )
  );
});
var ModelRoutes = () => <Component5 />;
export { modelCache, ModelRoutes, modelImports };
